<template>
  <div class="signIn">
    <div class="logo"><img src="../assets/image/epicas.png" alt=""></div>
    <div class="company"><p>数字化智能影像诊断平台管理系统</p></div>
    <div class="login_box">


      <el-tabs v-model="activeName">
        <el-tab-pane label="密码登录" name="pwd">
          <div class="phone_input">
            <el-input
                    tabindex="0"
                    v-model="userPhone"
                    placeholder="请输入手机号"
                    class="phoneInput"
            ></el-input>
          </div>
          <div class="phone_input" style="margin-top: 0;">
            <el-input
                    show-password
                    placeholder="请输入密码"
                    class="phoneInput"
                    v-model="password"
                    ref="input2"
            ></el-input>
          </div>
          <el-button
                  type="button"
                  class="z-login-btn"
                  @keyup.enter="webLoginByPassword"
                  @click="webLoginByPassword"
          >登&nbsp;&nbsp;录</el-button>
        </el-tab-pane>
        <el-tab-pane label="验证码登录" name="code">
          <!--<div class="title"><span>服务顾问登录</span></div>-->
          <div class="phone_input">
            <el-input
                    id="phoneInput"
                    tabindex="0"
                    v-model="userPhone"
                    placeholder="请输入手机号"
                    class="phoneInput"
            ></el-input>
          </div>
          <div class="get_code">
            <el-input
                    id="codeInput"
                    show-password
                    tabindex="1"
                    v-model="code"
                    placeholder="请输入验证码"
                    class="code_input"
                    onkeyup="this.value=this.value.replace(/[\W]/g,'');"
                    maxlength="8"
            ></el-input>
            <a  class="codeButton" tabindex="2" v-show="flag" @click="getCode">
              <div class="buttonText">获取验证码</div>
            </a>
            <a  class="codeButton" tabindex="2" v-show="!flag">
              <div class="buttonText">重新获取({{second}}s)</div>
            </a>
          </div>
          <el-button
                  type="button"
                  class="z-login-btn"
                  @keyup.enter="enter"
                  @click="login"
          >登&nbsp;&nbsp;录</el-button>
        </el-tab-pane>
      </el-tabs>



    </div>

  </div>
</template>

<script>
import net from "../assets/js/public";
import md5 from 'js-md5';
import $ from "jquery";
export default {
  name: "home",
  data() {
    return {
      codeImg: "", //验证码图片
      code: "",
      userPhone: "",
      password: "",
      loading2: false,
      uuId: "",
      baseCode: net.baseUrl + "admin/sa/StringCode?uuId=",
      flag: true,
      second: 59,
      title: "获取验证码",
      foucusIndex: 0,
      processElement: null,

      activeName: 'pwd',
    };
  },
  created() {
    var _this = this;
    document.onkeydown = function() {
      let key = window.event.keyCode;
      if (key == 13) {
        var sign = sessionStorage.getItem("signInfo");
        if (sign == null) {
          _this.handleEnter();
        }
      }
    };
  },
  mounted() {
    this.automaticLogin();
  },
  methods: {
    handleEnter() {
      if (this.activeName === 'code') {
        this.login();
      } else if (this.activeName === 'pwd') {
        this.webLoginByPassword();
      }
    },
    getCode() {
      if (!/^1[3456789]\d{9}$/.test(this.userPhone)) {
        net.message(this, "手机号码格式错误", "error");
        return false;
      }
      net
        .request("admin/sa/auth/getSmsCode", "post", { userPhone: this.userPhone})
        .then(res => {
          if (res.code == 0) {
            net.message(this, res.msg, "suucess");
            this.count_down();
            this.flag = false;
          } else {
            net.message(this, res.msg, "error");
            this.flag = true;
          }
        });
    },
    count_down() {
      var time = setInterval(() => {
        this.second = this.second - 1;
        if (this.second == 0) {
          clearInterval(time);
          this.second = 59;
          this.flag = true;
        }
      }, 1000);
    },
    login() {
      let params = {
        userPhone: this.userPhone,
        code: this.code,
      };
      this.loading2 = true;
      console.log(params)
      net.request("admin/sa/auth/webLogin", "post", params).then(res => {
        if (res.code == 0) {
          net.message(this, "登录成功", "success");
          sessionStorage.setItem("signInfo", JSON.stringify(res.data));
          net.setCookie("signInfo", JSON.stringify(res.data));
          let showInfo = {showMenu: false,active_tab:'1'}
          sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
          setTimeout(() => {
            this.loading2 = false;
            this.$router.push({ name: "saMain" });
          }, 1000);
        } else {
          net.message(this, res.msg, "warning");
          this.loading2 = false;
        }
      });
    },
    webLoginByPassword(){
      if (this.password == "") {
        net.message(this, "请输入密码", "warning");
      }
      let params = {
        loginUserName: this.userPhone,
        password: md5(this.password)
      };
      this.loading2 = true;
      net.request("admin/sa/auth/webLoginByPassword", "post", params).then(res => {
        console.log("res---",res)
        if (res.code == 0) {
          net.message(this, "登录成功", "success");
          sessionStorage.setItem("signInfo", JSON.stringify(res.data));
          net.setCookie("signInfo", JSON.stringify(res.data));
          let showInfo = {showMenu: false,active_tab:'1'}
          sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
          setTimeout(() => {
            this.loading2 = false;
            this.$router.push({ name: "saMain" });
          }, 1000);
        } else {
          net.message(this, res.msg, "warning");
          this.loading2 = false;
        }
      });
    },
    automaticLogin() {
      var signInfo = JSON.parse(net.getCookie("signInfo"));
      if (signInfo) {
        this.loading2 = true;
        net
          .request("admin/sa/auth/webToken", "post", { userPhone: signInfo.phone })
          .then(res => {
            if (res.code == 0) {
              net.message(this, "登录成功", "success");
              sessionStorage.setItem("signInfo", JSON.stringify(res.data));
              let showInfo = {showMenu: false,active_tab:'1'}
              sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
              setTimeout(() => {
                this.loading2 = false;
                this.$router.push({ name: "saMain" });
              }, 1000);
            } else {
              net.message(this, res.msg, "warning");
              this.loading2 = false;
            }
          });
      }
    }
  },
  components: {}
  // computed:mapState({
  //   count
  // })
};
</script>


<style lang="less">

  body {
    width: 100%;
    height: 100%;
    background: #F3F6FE;
    background: url("../assets/image/login.png") no-repeat;
    background-size: 100% 100%;
  }
</style>
<style lang="less" scoped>

  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    margin: 0;
    padding: 0;
    user-select:none;
  }
  a,
  button,
  input,
  select,
  textarea {
    outline: 0;
  }

  * {
    -webkit-tap-highlight-color: transparent;
  }

  a {
    color: #333;
    text-decoration: none;
  }

  img {
    margin: 0;
    padding: 0;
    border: none;
    vertical-align: middle;
  }

  html {
    font-family: "Helvetica Neue", Helvetica, STHeiTi, Arial, sans-serif;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }
  body {
    width: 100%;
    height: 100%;
    background: #F3F6FE;
    /*background: url("../assets/image/login.png") no-repeat;
    background-size: 100% 100%;*/
  }

  .content {
    /*width: 100%;*/
    /*height: 100vh;*/
  }
  .signIn {
    width: 1280px;
    height: 100%;
    margin: 0 auto;
    /*background-position: 0px 94px;*/
    .logo {
      text-align: left;
      margin-top: 89px;
    }
    .company {
      text-align: left;
      font-weight: 900;
      font-size: 40px;
      line-height: 53px;
      color: #0D0E12;
    }
    .login_box {
      float: right;
      width: 408px;
      height: 364px;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0px 15px 30px -2px rgba(210, 215, 222, 0.3);
      border-radius: 4px;
      .title {
        width: 100px;
        height: 50px;
        border-bottom: 3px solid #519AF6;
        margin-left: 28px;
        line-height: 50px;
        font-size: 16px;
        color: #519AF6;
      }
      .phone_input {
        margin: 40px 28px 22px 28px;
      }
      .get_code {
        overflow: hidden;
        .code_input {
          width: 262px;
          height: 44px;
          line-height: 44px;
          margin-left: 28px;
          float: left;
        }
        .codeButton {
          height: 44px;
          line-height: 44px;
          font-size: 14px;
          color: #519AF6;
          float: right;
          margin-right: 28px;
        }
      }
      .z-login-btn {
        width: 352px;
        height: 44px;
        margin-top: 40px;
        background: #519AF6;
        border-radius: 6px;
        text-align: center;
        font-size: 16px;
        color: #FFFFFF;
      }

      /deep/ .el-tabs__header {
        margin: 0;
        padding: 0 28px;
        border-bottom: none;
      }

      /deep/ .el-tabs__nav-wrap::after {
        display: none;
      }

      /deep/ .el-tabs__active-bar {
        background-color: #519AF6;
        height: 3px;
      }

      /deep/ .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        color: #333;

        &.is-active {
          color: #519AF6;
        }
      }

      .password_input {
        margin: 22px 28px;

        .el-input {
          width: 100%;
        }
      }
    }
  }

</style>
